import { StartClient } from "@tanstack/react-start/client";
import { hydrateRoot } from "react-dom/client";

// Disable React Strict Mode to avoid double-rendering issues
// with AI SDK's useChat hook (see: https://github.com/vercel/ai/pull/11509)
hydrateRoot(document, <StartClient />);
